import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from 'react';
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import swal from 'sweetalert';
import Select from 'react-select';
import { Modal, IconButton, Box, Tooltip, Backdrop, CircularProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

const SERVER_URL = process.env.REACT_APP_API_URL;

function MyWorkPlanInfoEdit() {
  const [weekDays, setWeekDays] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [setLoad, setSetLoad] = useState(true); // For loading state
  const location = useLocation(); // Accessing route state
  const [workPlanData, setWorkPlanData] = useState([])
  const [isModalOpen, setModalOpen] = useState(false);
  const [searchISLoading, setSearchIsLoading] = useState(false)
  const [selectedDayIndex, setSelectedDayIndex] = useState(null);
  const [action, setAction] = useState(null);


  const { startDate, endDate } = location.state || {};
  const navigate = useNavigate();

  // const yesterday = new Date();
  // yesterday.setDate(yesterday.getDate() - 1);


  // const isAllDaysPast = weekDays.every((day) => new Date(day.date) < yesterday);


  // const isAnyDayWithData = weekDays.some(
  //   (day) => day.work_plan || (day.selectedDays && day.selectedDays.length > 0)
  // );

  // const isReadOnly = (day) => new Date(day.date) < yesterday;

  useEffect(() => {
    const handlePopState = () => {
      // Perform the navigation when the back button is pressed
      navigate("/my_work_plan_info");
    };

    window.onpopstate = handlePopState;

    // Clean up on component unmount
    return () => {
      window.onpopstate = null;
    };
  }, [navigate]);


  useEffect(() => {

    // Function to fetch work plan data from API
    const fetchWorkPlanData = async () => {

      try {
        const headers = await getApiHeader(); // Assuming this is getting headers like Authorization
        const response = await axios.post(
          `${SERVER_URL}work-plan/get-my-work-plan-info`, // Ensure the URL is correct (added `/api/` for clarity)
          {
            start_date: startDate,
            end_date: endDate,
          },
          {
            headers: headers, // Pass headers correctly here
          }
        );

        if (response.status === 200) {
          const workPlanData = response.data.data.work_plan_data[0].work_plan;
          setWorkPlanData(workPlanData)

          // Map the data for weekDays and storeOptions
          const mappedWeekDays = workPlanData.map((workPlan) => ({
            date: workPlan.date,
            dayName: new Date(workPlan.date).toLocaleString('en-us', { weekday: 'long' }),
            selectedDays: workPlan.store_data.map(store => ({
              label: store.retailer_company_name,
              value: store.retailer_id,
            })),
            plan: workPlan.activity_notes, // The activity notes for that date
            work_plan: workPlan.work_plan_id,
            manager_comment: workPlan.manager_comments,
            work_date: workPlan.date,

          }));

          setWeekDays(mappedWeekDays);
          setStoreOptions(mappedWeekDays.map(day => day.selectedDays)); // Store options for each day

          setSetLoad(false); // Hide loader after data is fetched
        }
      } catch (error) {
        // console.error("Error fetching work plan data:", error);
        const errorMessage = error?.response?.data?.message || "Error fetching work plan data. Please try again.";
        toast.error(errorMessage);
        setSetLoad(false);
      }
    };

    fetchWorkPlanData();
  }, []); // Empty dependency array to run only on mount


  // Handle select changes
  const handleSelectChange = (selectedOptions, index) => {

    const updatedWeekDays = [...weekDays];
    updatedWeekDays[index].selectedDays = selectedOptions;

    setWeekDays(updatedWeekDays);
  };


  const handleTextChange = (value, index, field) => {

    const updatedWeekDays = [...weekDays];

    // Update the respective field based on the identifier
    if (field === 'plan') {
      updatedWeekDays[index].plan = value;
    } else if (field === 'manager_comment') {
      updatedWeekDays[index].manager_comment = value;
    }

    setWeekDays(updatedWeekDays);

  };

  const handleModalToggle = (index) => {
    setSelectedDayIndex(index);
    setModalOpen(!isModalOpen);
  };

  const handleActionClick = async (actionType) => {
    setAction(actionType); // Set the action to either 'approve' or 'reject'
    await handleWorkSubmit(actionType); // Call submit function with the action type
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleWorkSubmit = async (actionType) => {

    swal({
      title: 'Are you sure?',
      text: `Do you want to ${actionType} the work plan?`,
      icon: 'warning',
      buttons: {
        confirm: {
          text: 'Yes, submit it',
          className: 'btn-confirm',
        },
        cancel: {
          text: 'No, cancel',
          visible: true,
          className: 'btn-cancel',
        },
      },
      iconColor: '#e31579', // Optionally change the icon color
    }).then(async (isConfirmed) => {
      if (!isConfirmed) {
        // If the user cancels, don't submit
        return;
      }

      // Prepare the work plan data for submission
      const workPlanData = weekDays.map((day, index) => ({
        work_plan_id: day.work_plan || '',
        date: day.work_date,
        activity_notes: day.plan || '',
        manager_comments: day.manager_comment || '',
        stores: day.selectedDays.map(store => store.value),  // Map store selections to store IDs
      }));

      const formData1 = {

        work_plan_data: workPlanData,
      };

      try {
        setSetLoad(true);
        const headers = await getApiHeader(); // Ensure this returns the correct headers

        const response = await axios.post(
          `${SERVER_URL}work-plan/edit-my-work-plan`,  // Ensure the URL is correct
          formData1,
          {
            headers: headers,
          }
        );

        if (response.status === 200) {

          const successMessage = response.data.message || `Work plan ${actionType}ed successfully`;

          //toast.success(successMessage);
          // Show success message using SweetAlert
          swal({
            title: "Success",
            text: successMessage,
            icon: "success",
            button: "Close",
          }).then(() => {
            // Optionally navigate or update the UI after success
            setTimeout(() => {
              window.location.href = '/list_my_work_plan';
            }, 3000);
          });

          setTimeout(() => {
            window.location.href = '/list_my_work_plan';
          }, 3000);
        }
      } catch (error) {

        const errorMessage = error?.response?.data?.message || "Error submitting work plan. Please try again.";
        // toast.error(errorMessage);
        // Show error message if there's an issue
        swal({
          title: "Error",
          text: errorMessage,
          icon: "error",
          button: "Close",
        });
        setSetLoad(false);
      }
    });
  };

  const [formData, setFormData] = useState({
    retailer_code: "",
    store_name: "",
    email: "",
    abn: "",
    state: "",
    city: "",
    postcode: "",
    street_name: "",
  });


  const handleSubmit = async (e) => {

    e.preventDefault();
    setSetLoad(true)
    if (
      formData.retailer_code === "" &&
      formData.store_name === "" &&
      formData.email === "" &&
      formData.abn === "" &&
      formData.state === "" &&
      formData.city === "" &&
      formData.postcode === "" &&
      formData.street_name === ""
    ) {
      toast.error("At least one input field must be filled");
      setSetLoad(false)
      return;
    } else if (formData.street_name && (formData.city === "" && formData.postcode === "")) {
      toast.error("Please enter  post code or city name");
      setSetLoad(false)
      return;
    } else if (formData.state && (formData.city === "" && formData.postcode === "")) {
      toast.error("Please enter street name or post code");
      setSetLoad(false)
      return;
    }
    //console.log("formdata---->", formData);
    const headers = await getApiHeader();
    const filteredFormData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== "")
    );
    try {
      const response = await axios.post(`${SERVER_URL}search-retailer-store`, filteredFormData, {
        headers: headers
      });

      const options = response.data.data.map((value) => ({
        label: value.retailer_company_name,
        // value: value.retailer_code,
        value: value.retailer_id,

      }));

      const updatedStoreOptions = weekDays.map((day, index) => {
        return {
          ...day,
          options: options,
        };
      });


      setStoreOptions(updatedStoreOptions);

      setModalOpen(false)
      setSetLoad(false)

      if (options.length === 0) {
        toast.error("No Shop details Found.");
      } else {
        toast.success("Shop details are populated.");
      }


    } catch (error) {
      console.log("error---------->", error);
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container">
        {setLoad ? (
          <Backdrop
            open={true}
            style={{
              color: '#fff',
              zIndex: 9999,
            }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : (
          <form className="workplanform col-lg-12" onSubmit={(e) => e.preventDefault()}>
            {weekDays?.length > 0 && (
              <>
                <div className="row align-items-center mb-3">
                  <label htmlFor="plan-details" className="label col-12">
                    {location.state ? 'Edit Work Plan Details:' : 'Add Work Plan Details:'}
                  </label>
                  {weekDays.map((day, index) => (
                    <div className="row mb-4" key={index}>
                      <div className="col-md-3">
                        <input
                          className="form-control p-3"
                          value={`${day.date} - ${day.dayName}`}
                          readOnly
                          style={{
                            borderRadius: '5px',
                            padding: '5px',
                          }}
                          aria-label={`${day.dayName} date`}
                        />
                        <input type="hidden" name="work_plan" value={day.work_plan || ''} />
                        <input type="hidden" name="work_date" value={day.work_date || ''} />
                      </div>

                      <div className="col-md-8">
                        <Select
                          isMulti
                          options={storeOptions[index]?.options || []}
                          value={day.selectedDays}
                          onChange={(selectedOptions) => handleSelectChange(selectedOptions, index)}
                          placeholder="Search and add stores for revisits."
                          className="basic-multi-select select-workplan-place-holder"
                          classNamePrefix="select"
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              borderRadius: '5px',
                              padding: '5px',
                            }),
                            multiValue: (provided) => ({
                              ...provided,
                              backgroundColor: '#c11d6c',
                              color: 'white',
                              padding: '1px',
                            }),
                            multiValueLabel: (provided) => ({
                              ...provided,
                              color: 'white',
                            }),
                          }}
                        // isDisabled={isReadOnly(day)}  // Read-only if the day is in the past
                        />
                      </div>

                      <div className="col-md-1">
                        <Tooltip title="Search details of stores" placement="bottom-end">
                          <IconButton

                            // onClick={() => {
                            //   if (!isReadOnly(day)) { 
                            //     handleModalToggle(index);
                            //   }
                            // }}
                            onClick={() => handleModalToggle(index)}
                            aria-label="search"
                            style={{
                              marginLeft: '10px',
                              transition: 'transform 0.2s',
                            }}
                            //disabled={isReadOnly(day)} 
                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                          >
                            <SearchIcon
                              sx={{
                                color: '#e20e75',
                                transition: 'transform 0.2s, color 0.2s',
                                '&:hover': {
                                  transform: 'scale(1.2)',
                                  color: '#d50b66',
                                },
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </div>

                      <br />

                      <div className="col-md-12 mt-3">
                        <ReactQuill
                          value={day.plan || ''}
                          onChange={(value) => handleTextChange(value, index, 'plan')}
                          placeholder="Please provide your planned activities, such as details of new shop visits, shop revisits, and any other relevant tasks."
                          modules={{
                            toolbar: [
                              [{ header: [1, 2, false] }],
                              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                              ['link'],
                              ['clean'],
                            ],
                          }}
                          style={{
                            borderColor: '#e20e75',
                            borderRadius: '5px',
                            height: '150px',
                            marginBottom: '55px',
                          }}
                        // readOnly={isReadOnly(day)} // Read-only if the day is in the past
                        />
                      </div>

                      <label htmlFor="plan-details" className="label col-12">
                        Reporting Manager Comments
                      </label>
                      <div className="col-md-12 mt-3">
                        <ReactQuill
                          value={day.manager_comment || ''}
                          onChange={(value) => handleTextChange(value, index, 'manager_comment')}
                          placeholder="Provide your comments."
                          modules={{
                            toolbar: [
                              [{ header: [1, 2, false] }],
                              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                              ['link'],
                              ['clean'],
                            ],
                          }}
                          style={{
                            borderColor: '#e20e75',
                            borderRadius: '5px',
                            height: '150px',
                            marginBottom: '55px',
                          }}
                          readOnly={true} // Make the editor read-only
                        />
                      </div>
                    </div>
                  ))}
                </div>

                {/* Submit button */}
                {/* <button
                type="button"
                className={`submit-button ${isAllDaysPast || !isAnyDayWithData ? 'disabled' : ''}`}
                onClick={() => handleActionClick('submit')}
                disabled={isAllDaysPast || !isAnyDayWithData} 
              >
                Submit
              </button> */}
                <button
                  type="button"
                  className={`submit-button`}
                  onClick={() => handleActionClick('submit')}
                >
                  Submit
                </button>
              </>
            )}
            <br />
          </form>
        )}
      </div>

      <Modal open={isModalOpen} onClose={handleModalToggle}>

        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            bgcolor: 'background.paper',
            outline: 'none',
            //  boxShadow: 24,
            //  p: 4,
            borderRadius: 2,
            '@media (max-width: 950px)': {
              maxHeight: '90%',
              overflowY: 'auto',
            },
            '@media (max-width: 740px)': {
              maxHeight: '90%',
              overflowY: 'auto',
            },
            '@media (max-width: 480px)': {
              width: '350px', // For very small screens (e.g., 350px)
              maxHeight: '90%',
              overflowY: 'auto',
            },
          }}
        >

          {/* Close Button */}
          {!setLoad && (
            <button
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'transparent',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: 'black',
              }}
              onClick={handleModalToggle} // This will close the modal
            >
              &times; {/* This is the "×" symbol */}
            </button>
          )}

          {setLoad ? (
            <Backdrop
              open={true}
              style={{
                color: '#fff',
                zIndex: 9999,
              }}
            >
              <CircularProgress color="inherit" />
            </Backdrop>


          ) : (
            <form action="" method="" onSubmit={handleSubmit} autoComplete="off">
              <div className="formbold-mb-5 formbold-pt-3">
                <label className="formbold-form-label formbold-form-label-2">
                </label>
                <div className="flex flex-wrap formbold--mx-3">
                  <div className="w-full sm:w-half formbold-px-3">
                    <label htmlFor="store_name" className="formbold-form-label">
                      Store Name
                    </label>
                    <div className="formbold-mb-5">
                      <input
                        type="text"
                        name="store_name"
                        id="store_name"
                        placeholder="Enter Store Name"
                        className="form-control"
                        value={formData.store_name}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                    </div>
                  </div>

                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        Email  Address
                      </label>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Enter Email Address"
                        className="form-control"
                        value={formData.email}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                    </div>
                  </div>

                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        Retailer ID
                      </label>
                      <input
                        type="text"
                        name="retailer_code"
                        id="retailer_code"
                        placeholder="Enter Retailer ID"
                        className="form-control"
                        value={formData.retailer_code}
                        onChange={handleChange}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        ABN
                      </label>
                      <input
                        type="text"
                        name="abn"
                        id="abn"
                        placeholder="Enter ABN"
                        className="form-control"
                        value={formData.abn}
                        onChange={handleChange}
                        maxLength={12}
                        autoComplete="off"
                      />
                    </div>
                  </div>

                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        City
                      </label>
                      <input
                        type="text"
                        name="city"
                        id="city"
                        placeholder="Enter City Name"
                        className="form-control"
                        value={formData.city}
                        onChange={handleChange}
                        autoComplete="new-password"
                      />
                    </div>
                  </div>
                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        Post Code
                      </label>
                      <input
                        type="text"
                        name="postcode"
                        id="postcode"
                        placeholder="Enter Post Code"
                        className="form-control"
                        autoComplete="new-password"
                        value={formData.postcode}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="w-full sm:w-half formbold-px-3">
                    <div className="formbold-mb-5">
                      <label htmlFor="store_name" className="formbold-form-label">
                        Street Name
                      </label>
                      <input
                        type="text"
                        name="street_name"
                        id="street_name"
                        placeholder="Enter Street Name"
                        className="form-control"
                        autoComplete="new-password"
                        value={formData.street_name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="w-full sm:w-half formbold-px-3">
                    <label htmlFor="store_name" className="formbold-form-label">
                      State
                    </label>
                    <select
                      className="form-control"
                      name="state"
                      id="state"
                      value={formData.state}
                      onChange={handleChange}
                    >
                      <option value="">Select State</option>
                      <option value="Act">ACT</option>
                      <option value="NSW">NSW</option>
                      <option value="NIT">NIT</option>
                      <option value="QLD">QLD</option>
                      <option value="SA">SA</option>
                      <option value="TAS">TAS</option>
                      <option value="VIC">VIC</option>
                      <option value="WA">WA</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="search-store-buttons">
                <button className="search-store-button" type="submit"><i class="fa fa-search"></i> Search</button>

              </div>
            </form>
          )}
        </Box>
      </Modal>


    </DashboardLayout>
  );
}

export default MyWorkPlanInfoEdit;
